/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ top: NonNullable<unknown> }} Perks_Head_TopInputs */



/**
* | output |
* | --- |
* | "Top {top}" |
*
* @param {Perks_Head_TopInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const perks_head_top = /** @type {((inputs: Perks_Head_TopInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Perks_Head_TopInputs, { locale?: "en" | "ru" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ (`Топ-${i?.top}`)
	return /** @type {LocalizedString} */ (`Top ${i?.top}`)
});